export default __webpack_public_path__ + "static/media/thumbnail.11f024c4.png";